// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Ix2_s","left":"InfoRow_left__1oQZB"};